import { render, staticRenderFns } from "./PackingManifest.vue?vue&type=template&id=3bf90012&scoped=true"
import script from "./PackingManifest.vue?vue&type=script&lang=js"
export * from "./PackingManifest.vue?vue&type=script&lang=js"
import style0 from "./PackingManifest.vue?vue&type=style&index=0&id=3bf90012&prod&scoped=true&lang=css"
import style1 from "./PackingManifest.vue?vue&type=style&index=1&id=3bf90012&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf90012",
  null
  
)

export default component.exports